<template>
	<div>
		<RecommendBrandRegister mode="modify" />
	</div>
</template>
<script>
	import RecommendBrandRegister from '@/components/advertisement/RecommendBrandRegister.vue';
	export default {
		components: { RecommendBrandRegister },
	};
</script>
<style lang="scss" scoped></style>
